import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getChatHistory } from '@/api/workstation'

const DEFAULT_ITEMS_PER_PAGE = 7

function getDefaultDateRange() {
  const endDate = new Date()
  const startDate = new Date()
  startDate.setDate(startDate.getDate() - 30)
  return { startDate, endDate }
}

export interface UseChatHistoryQueryParams {
  page: number
  filter: string
  itemsPerPage?: number
  enabled?: boolean
}

export function useChatHistoryQuery({
  page,
  filter,
  itemsPerPage = DEFAULT_ITEMS_PER_PAGE,
  enabled = true,
}: UseChatHistoryQueryParams) {
  const { startDate, endDate } = useMemo(() => getDefaultDateRange(), [])

  return useQuery({
    queryKey: ['chat-history', page, filter, itemsPerPage, startDate, endDate],
    queryFn: () =>
      getChatHistory({
        currentPage: page,
        itemsPerPage,
        startDate,
        endDate,
        filter,
        feedbackFilter: 'all',
        metadataFilter: {},
      }),
    enabled,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    placeholderData: (previousData) => previousData,
  })
}
